import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api/client';

const ThemeContext = createContext({ theme: null, refresh: () => {} });

const FONT_LINKS = {
  Cinzel: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700;900&display=swap',
  Inter: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
  Montserrat: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap',
  Oswald: 'https://fonts.googleapis.com/css2?family=Oswald:wght@500;700&display=swap',
  Playfair: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;800&display=swap',
  Poppins: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap',
  Roboto: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap',
};

function ensureFont(name) {
  if (!name || !FONT_LINKS[name]) return;
  const id = `gf-${name}`;
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = FONT_LINKS[name];
  document.head.appendChild(link);
}

function applyTheme(t) {
  if (!t) return;
  const r = document.documentElement.style;
  r.setProperty('--theme-primary', t.theme_color_primary || '#001f3f');
  r.setProperty('--theme-accent', t.theme_color_accent || '#ec4899');
  r.setProperty('--theme-secondary', t.theme_color_secondary || '#0ea5e9');
  r.setProperty('--theme-font-display', `'${t.theme_font_display || 'Cinzel'}', serif`);
  r.setProperty('--theme-font-body', `'${t.theme_font_body || 'Inter'}', sans-serif`);
  r.setProperty('--theme-hero-height', `${t.theme_hero_height || 85}vh`);
  ensureFont(t.theme_font_display);
  ensureFont(t.theme_font_body);
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(null);

  const load = async () => {
    try {
      const s = await api.getSettings();
      if (s && Object.keys(s).length > 0) {
        applyTheme(s);
        setTheme(s);
      }
    } catch {
      // backend non disponibile: usa default
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <ThemeContext.Provider value={{ theme, refresh: load }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
export { applyTheme };
